import { render, staticRenderFns } from "./custom-detail.vue?vue&type=template&id=58b1d9ff&scoped=true&"
import script from "./custom-detail.vue?vue&type=script&lang=js&"
export * from "./custom-detail.vue?vue&type=script&lang=js&"
import style0 from "./custom-detail.vue?vue&type=style&index=0&id=58b1d9ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1d9ff",
  null
  
)

export default component.exports